import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type PasswordRequirement = {
  key: string;
  label: string;
  isValid: boolean;
};

export const usePasswordRequirements = (password: string) => {
  const { t } = useTranslation();

  const requirements = useMemo<PasswordRequirement[]>(
    () => [
      {
        key: 'minLength',
        label: t('front.auth.passwordEdit.form.requirements.minLength'),
        isValid: password.length >= 8,
      },
      {
        key: 'letters',
        label: t('front.auth.passwordEdit.form.requirements.letters'),
        isValid: /[A-Za-z]/.test(password),
      },
      {
        key: 'digits',
        label: t('front.auth.passwordEdit.form.requirements.digits'),
        isValid: /\d/.test(password),
      },
      {
        key: 'specialCharacter',
        label: t('front.auth.passwordEdit.form.requirements.specialCharacter'),
        isValid: /[^A-Za-z0-9]/.test(password),
      },
    ],
    [password, t],
  );

  const isPasswordValid = requirements.every(
    (requirement) => requirement.isValid,
  );

  return {
    requirements,
    isPasswordValid,
  };
};
